import { render } from "./Page4Component.vue?vue&type=template&id=50e13081"
import script from "./Page4Component.vue?vue&type=script&lang=js"
export * from "./Page4Component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\grego\\Documents\\Projets_info\\New-project\\gregoire-aimier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__